import * as React from "react";
import WideDrawer from "../../../../components/general/WideDrawer.tsx";
import {SecondaryButton} from "../../../../components/general/SecondaryButton.tsx";
import {RODeveloperDocumentDataViewer} from "./RODeveloperDocumentDataViewer.tsx";
import {DocumentPreview} from "../../../../views/DocumentDrawer/components/DocumentPreview.tsx";
import {TFICDocument} from "../../../../views/DocumentDrawer/types/Document.ts";
import {RODeveloperDocument} from "../types.ts";
import {cleanDocumentFileName} from "../../../../lib/TFICLib.ts";

interface RODeveloperDocumentDrawerProps {
    isOpen: boolean;
    onClose: () => void;
    document: RODeveloperDocument | null;
    fullDocument: TFICDocument | null;
    isFetching: boolean;
    onNext: () => void;
    onPrevious: () => void;
    currentIndex: number;
    totalDocuments: number;
}


export const RODeveloperDocumentDrawer = ({
                                              isOpen,
                                              onClose,
                                              document,
                                              fullDocument,
                                              isFetching,
                                              onNext,
                                              onPrevious,
                                              currentIndex,
                                              totalDocuments,
                                          }: RODeveloperDocumentDrawerProps) => {

    const headerContent = (
        <div className="flex items-center justify-between w-full pr-8">
            <h2 className="text-lg font-medium text-gray-900 truncate max-w-[500px]" title={document?.file_name}>
                {document ? cleanDocumentFileName(document.file_name) : 'Document Details'}
            </h2>
            <div className="flex items-center gap-4 pl-6">
                <span className="text-sm text-gray-500">
                    {totalDocuments > 0 ? `${currentIndex + 1} / ${totalDocuments}` : '-'}
                </span>
                <SecondaryButton
                    title="Previous"
                    onClick={onPrevious}
                    disabled={currentIndex <= 0}
                />
                <SecondaryButton
                    title="Next"
                    onClick={onNext}
                    disabled={currentIndex >= totalDocuments - 1}
                />
            </div>
        </div>
    );

    const displayDoc = fullDocument;

    return (
        <WideDrawer
            open={isOpen}
            updateOpenState={onClose}
            title={headerContent}
            width={'xl'}
        >
            {displayDoc ? (
                <div className="p-6 relative">
                    {isFetching && (
                        <div className="absolute inset-0 z-10 bg-white/50 flex items-center justify-center backdrop-blur-[1px]">
                            <img className="size-12" src="https://app.pocketcfo.io/loader-slow.gif" alt="loader" />
                        </div>
                    )}
                    <div className="grid grid-cols-1 lg:grid-cols-12 gap-6">
                        <div className="lg:col-span-4">
                            <RODeveloperDocumentDataViewer document={displayDoc} />
                        </div>
                        <div className="lg:col-span-8">
                            <div className="bg-white p-6 rounded-lg shadow-sm border border-gray-200 sticky top-0">
                                <h3 className="text-lg font-bold text-gray-900 mb-4 border-b pb-2 flex justify-between items-center">
                                    Preview
                                    <span className="text-xs font-normal text-gray-500 font-mono truncate ml-4" title={displayDoc.file_name}>
                                            {displayDoc.file_name}
                                        </span>
                                </h3>
                                <div className="border border-gray-200 rounded-lg overflow-auto bg-gray-50 max-h-[80vh] flex items-start justify-center p-4">
                                    {displayDoc.file_blob ? (
                                        <div className="w-full max-w-2xl">
                                            <DocumentPreview
                                                document={displayDoc}
                                            />
                                        </div>
                                    ) : (
                                        <div className="flex items-center justify-center h-[600px] text-gray-400">
                                            {isFetching ? 'Loading preview...' : 'No preview available'}
                                        </div>
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            ) : (
                <div className="flex items-center justify-center h-full text-gray-500">
                    No document selected
                </div>
            )}
        </WideDrawer>
    );
};
